export default theme => ({
  control: base => ({
    ...base,
    border: 'none',
    boxShadow: '0 0',
    borderRadius: 0,
    '&:hover': {
      border: 'none',
      boxShadow: '0 0'
    }
  }),
  indicatorSeparator: base => ({
    display: 'none'
  }),
  singleValue: base => ({
    ...base,
    color: 'red'
  }),
  menu: base => ({
    ...base,
    marginTop: 0,
    borderRadius: 0,
    boxShadow: '0 4px 2px -2px hsla(0,0%,0%,0.1), 0 4px 11px hsla(0,0%,0%,0.1)',
    font: "300 16px 'Roboto', sans-serif",
  }),
  dropdownIndicator: base => ({
    ...base,
    color: theme
  })
});
